export function formatMoney(amount, currency, custom_precision) {
  if (!currency) {
    currency = {
      precision: custom_precision,
      thousand_separator: ".",
      decimal_separator: ","
      //symbol: "USD"
    };
  }

  if (custom_precision === 2 ) {
      amount = amount / 100;
  } else {
      amount = amount / 1000;
  }

  let {
    precision,
    decimal_separator,
    thousand_separator
    //symbol
  } = currency;

    try {
        precision = Math.abs(precision);
        precision = isNaN(precision) ? 2 : precision;

        // Rundung auf gewünschte Dezimalstellen mit Trennung
        const negativeSign = amount < 0 ? "-" : "";
        const absAmount = Math.abs(amount);
        const multiplier = Math.pow(10, precision);
        const roundedValue = Math.round((absAmount + Number.EPSILON) * multiplier) / multiplier;
        const fixed = roundedValue.toFixed(precision);
        const parts = fixed.split(".");
        let intPart = parts[0];
        const decPart = parts[1] || "";
        // Tausendertrennzeichen einfügen
        intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousand_separator);
        return (
            negativeSign +
            intPart +
            (precision ? decimal_separator + decPart : "")
        );
    } catch (e) {
        //console.log(e);
    }
}
